import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExternalChannelParentMessageService {
  private platformId = inject(PLATFORM_ID);


  notifyHubClosed(): boolean {
    if (!isPlatformBrowser(this.platformId) || !this.isInsideIframe()) {
      return false;
    }

    const targetOrigin = this.getTargetOrigin();
    if (!targetOrigin) {
      return false;
    }

    try {
      window.parent.postMessage({ type: 'HUB_CLOSED' }, targetOrigin);
      return true;
    } catch {
      return false;
    }
  }

  private isInsideIframe(): boolean {
    return window.parent !== window;
  }

  private getTargetOrigin(): string {
    try {
      return new URL(environment.mceRedirectUrl).origin;
    } catch {
      return '';
    }
  }
}
